export const state = {
  data: [],
  docType: ''
}

export const mutations = {
  SET_DOCTYPE (state, payload) {
    state.docType = payload
  },
  SET_DATA (state, payload) {
    state.data = payload
  }
}
